import React from 'react';
import './index.scss';

export const LogInButton = ({ icon, title, subtitle, url }) => {
  return (
    <a href={url} className="login-select-btn">
      {icon}
      <div>
        <h2>{title}</h2>
        <p>{subtitle}</p>
      </div>
    </a>
  );
};
